import { useGetAllAliasTables } from '@api/tia/TiaAliasTableApiHooks';
import { Box } from '@stereograph/teia-system-design/components/Box';
import { CircularProgress } from '@stereograph/teia-system-design/components/Progress';
import { Stack } from '@stereograph/teia-system-design/components/Stack';

import { AliasEditorView } from './AliasEditorView';

import { useState, useEffect } from 'react';
import { Button } from '@stereograph/teia-system-design/components/Button';
import { Alias, CompleteAlias } from '@api/tia/TiaAliasTableApi';

export const AliasTableView = () => {
  const { data: fetchedAliases, isLoading } = useGetAllAliasTables();
  const [aliases, setAliases] = useState<Array<CompleteAlias | Alias>>([]);

  useEffect(() => {
    if (fetchedAliases) {
      setAliases(fetchedAliases);
    }
  }, [fetchedAliases]);

  const handleAddAlias = () => {
    setAliases([defaultAlias(), ...aliases]);
  };

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'scroll',
    }}
    >
      {!!isLoading && (
        <Box sx={{
          flexGrow: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        >
          <CircularProgress variant="indeterminate" />
        </Box>
      )}
      {!!aliases && (
        <>
          <Button
            variant="contained"
            onClick={handleAddAlias}
            sx={{
              mb: 2,
              alignSelf: 'flex-start',
            }}
          >
            Add Alias
          </Button>
          <Stack spacing={{
            xs: 2,
          }}
          >
            {aliases.map((item, index) => (
              <AliasEditorView key={'id' in item ? item.id : index} inputAlias={item} />
            ))}
          </Stack>
        </>
      )}
    </Box>
  );
};

const defaultAlias = (): Alias => {
  return {
    name: 'string',
    alias: {
      data_sources: [
        {
          operator: 'EqualTo',
          value: 'myValue',
          value_type: 'string',
          type: 'bim_data',
          prop: 'Element Specific',
          name: 'Type',
        },
        {
          operator: 'Contains',
          value: 'myValue',
          value_type: 'string',
          type: 'open_data',
          key: 'myKey',
        },
        {
          operator: 'StartWith',
          value: 'myValue',
          value_type: 'string',
          type: 'user_data',
          app_name: 'myAppName',
          name: 'myName',
        },
      ],
    },
  };
};
